__turbopack_context__.v({
  "results": "ResultList-module___r-_CG__results",
});
